// Cache DOM elements
const headerWrapper = document.querySelector(".header-wrapper");
const hostname = window.location.hostname;
const searchModal = document.getElementById("searchModalSection");
const headerSearch = document.getElementById("headerSearch");

// Optimize external link processing with for...of loop
const links = document.links;
for (const link of links) {
  if (link.hostname !== hostname) {
    link.target = "_blank";
    link.rel = "noreferrer noopener";
  }
}

// Throttled scroll handler for better performance
let scrollTimeout;
window.addEventListener("scroll", function() {
  if (scrollTimeout) {
    return;
  }
  
  scrollTimeout = setTimeout(() => {
    if (window.scrollY > 30) {
      headerWrapper.classList.add("sticky");
    } else {
      headerWrapper.classList.remove("sticky");
    }
    scrollTimeout = null;
  }, 16); // ~60fps
});

// Optimize menu items with event delegation
const headerMenu = document.querySelector(".header__inline-menu");
if (headerMenu) {
  const menuItems = headerMenu.querySelectorAll("details");
  
  menuItems.forEach((item) => {
    const summary = item.querySelector("summary");
    
    item.addEventListener("mouseenter", () => {
      item.setAttribute("open", "true");
      summary.setAttribute("aria-expanded", "true");
      item.classList.add("mega-menu-animate");
    });
    
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      summary.setAttribute("aria-expanded", "false");
      item.classList.remove("mega-menu-animate");
    });
  });
}

function openSearchDrawer() {
  if (searchModal && headerSearch) {
    searchModal.classList.add("open");
    headerSearch.classList.remove("hidden");
    headerSearch.focus();
  }
}

function closeSearchDrawer() {
  if (searchModal && headerSearch) {
    searchModal.classList.remove("open");
    headerSearch.classList.add("hidden");
    headerSearch.blur();
  }
}

function topFunction() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

function openMenuTab(evt, menuTabName) {
  const tabContents = document.getElementsByClassName("menu-tab-content");
  const tablinks = document.getElementsByClassName("menu-tablink");
  
  // Use for...of for better performance
  for (const content of tabContents) {
    content.style.display = "none";
  }
  
  for (const link of tablinks) {
    link.classList.remove("tab-active");
  }
  
  const targetTab = document.getElementById(menuTabName);
  if (targetTab) {
    targetTab.style.display = "block";
  }
  
  if (evt.currentTarget) {
    evt.currentTarget.classList.add("tab-active");
  }
}

function updatePrice() {
  const prices = document.querySelectorAll(".price-item");
  
  // Use more efficient regex and for...of loop
  const priceRegex = /\.00(?=\s|$)|,00(?=\s|$)/g;
  
  for (const price of prices) {
    const text = price.textContent;
    if (priceRegex.test(text)) {
      price.textContent = text.replace(priceRegex, '');
    }
  }
}

document.addEventListener('DOMContentLoaded', updatePrice);

/**
 * CartAttributes - UpCart Integration
 * 
 * Manages cart attributes for UpCart third-party cart drawer.
 * 
 * Usage in Liquid:
 * <cart-attributes 
 *   data-subscribe="true" 
 *   data-third-parties="true"
 *   data-subscribe-label="Custom subscribe text"
 *   data-third-parties-label="Custom third parties text">
 * </cart-attributes>
 */
class CartAttributes extends HTMLElement {
  connectedCallback() {
    this.nameSubscribe = 'attributes[catalogue-subscribe]'
    this.nameThird = 'attributes[catalogue-third-parties]'
    this.labels = {
      subscribe: this.dataset.subscribeLabel || "I'd like to receive the SIRPLUS catalogue",
      third: this.dataset.thirdPartiesLabel || "I would like to hear from carefully selected friends of SIRPLUS"
    }
    this.flags = {
      subscribe: String(this.dataset.subscribe).toLowerCase() === 'true',
      third: String(this.dataset.thirdParties).toLowerCase() === 'true'
    }
    
    this.render()
    this.bindEvents()
    this.injectContent()
  }

  render() {
    const wrapper = document.createElement('div')
    wrapper.className = 'cart__attributes'
    if (this.flags.subscribe) {
      wrapper.appendChild(this.buildField(this.nameSubscribe, this.labels.subscribe))
    }
    if (this.flags.third) {
      wrapper.appendChild(this.buildField(this.nameThird, this.labels.third))
    }
    this.wrapper = wrapper
  }

  buildField(name, labelText) {
    const p = document.createElement('p')
    p.className = 'cart-attribute__field'
    const hidden = document.createElement('input')
    hidden.type = 'hidden'
    hidden.name = name
    hidden.value = 'No'
    const checkbox = document.createElement('input')
    checkbox.type = 'checkbox'
    checkbox.name = name
    checkbox.value = 'Yes'
    checkbox.checked = true
    const label = document.createElement('label')
    label.textContent = labelText
    label.style.marginLeft = '5px'
    label.style.fontSize = '0.8em'
    p.appendChild(hidden)
    p.appendChild(checkbox)
    p.appendChild(label)
    return p
  }

  bindEvents() {
    this.addEventListener('change', e => {
      if (!(e.target instanceof HTMLInputElement)) return
      if (e.target.name !== this.nameSubscribe && e.target.name !== this.nameThird) return
      const attrs = this.collectValues()
      this.updateUpCart(attrs)
    })
  }

  injectContent() {
    if (this.children.length === 0) {
      const clonedChildren = Array.from(this.wrapper.children)
      clonedChildren.forEach(child => {
        this.appendChild(child.cloneNode(true))
      })
    }
  }

  collectValues() {
    const fields = this.wrapper.querySelectorAll('input[type="checkbox"]')
    const result = {}
    
    // Use for...of for better performance
    for (const cb of fields) {
      const key = cb.name.replace(/^attributes\[(.+)\]$/, '$1')
      result[key] = cb.checked ? 'Yes' : 'No'
    }
    return result
  }

  updateUpCart(attributes) {
    if (window.upcart && window.upcart.setCartAttributes) {
      window.upcart.setCartAttributes(attributes)
    }
  }
}

customElements.define('cart-attributes', CartAttributes)

// Wait for UpCart cart:opened event with optimized retry logic
document.addEventListener('DOMContentLoaded', () => {
  let retryCount = 0;
  const maxRetries = 3;
  
  function setupUpCartListener() {
    const upcart = window.upcart || window.UpCart || window.Upcart
    
    if (upcart && upcart.on) {
      upcart.on('cart:opened', () => {
        const cartAttributes = document.querySelectorAll('cart-attributes')
        for (const element of cartAttributes) {
          if (element.injectContent) {
            element.injectContent()
          }
        }
      })
    } else if (retryCount < maxRetries) {
      retryCount++
      setTimeout(setupUpCartListener, 1000 * retryCount) // Exponential backoff
    }
  }
  
  setupUpCartListener()
})

document.addEventListener('DOMContentLoaded', () => {
  const bodyObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const hadUpcartPopupShow = mutation.oldValue?.split(/\s+/).includes('upcartPopupShow')
        const hasUpcartPopupShow = document.body.classList.contains('upcartPopupShow')
        const hasOpenModal = document.querySelector(
          'modal-dialog[open], details-modal[open], cart-drawer.active, pickup-availability-drawer[open]'
        )

        if (hadUpcartPopupShow && !hasUpcartPopupShow && !hasOpenModal) {
          document.body.classList.remove('overflow-hidden')
        }
      }
    })
  })

  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
    attributeOldValue: true
  })
})

// UpCart Event Monitoring
document.addEventListener('DOMContentLoaded', () => {
  // Monitor UpCart cart opened event  
  if (typeof window.upcartSubscribeCartOpened === 'function') {
    window.upcartSubscribeCartOpened((cart) => {
      // Set up add-on toggle monitoring when cart opens with retry logic for mobile
      let retryCount = 0;
      const maxRetries = 5;
      const retryDelay = 300;
      
      function attemptSetup() {
        const upcartElement = document.getElementById('upCart');
        const shadowRoot = upcartElement?.shadowRoot;
        const addonToggle = shadowRoot?.querySelector('.upcart-addons-toggle');
        
        if (addonToggle) {
          setupAddonToggleMonitor();
        } else if (retryCount < maxRetries) {
          retryCount++;
          setTimeout(attemptSetup, retryDelay);
        }
      }
      
      setTimeout(attemptSetup, 200);
    });
  }
});

// Monitor add-on toggle active state
function setupAddonToggleMonitor() {
  const upcartElement = document.getElementById('upCart');
  if (!upcartElement) return;

  const shadowRoot = upcartElement.shadowRoot;
  if (!shadowRoot) return;

  const addonToggle = shadowRoot.querySelector('.upcart-addons-toggle');
  if (!addonToggle) return;

  const toggleSwitch = addonToggle.querySelector('.styles_ToggleSwitch__');
  if (!toggleSwitch) return;

  // Get the text elements
  const titleElement = shadowRoot.querySelector('.upcart-addons-title');
  const descriptionElement = shadowRoot.querySelector('.upcart-addons-product-description');
  
  // Look for price elements that might contain the £3.99 text
  const priceElements = shadowRoot.querySelectorAll('*');
  let priceElement = null;
  
  // Search for elements containing the price text
  for (const element of priceElements) {
    if (element.textContent && element.textContent.includes('£3.99')) {
      priceElement = element;
      break;
    }
  }
  
  // Store original content
  const originalTitle = titleElement ? titleElement.textContent : '';
  const originalDescription = descriptionElement ? descriptionElement.innerHTML : '';

  // Create "How does it work?" button function for reuse
  function createHowItWorksButton() {
    const button = document.createElement('button');
    button.id = 'kvatt-how-it-works-button';
    button.textContent = 'How does it work?';
    button.style.cssText = `
      background: none;
      border: none;
      padding: 0;
      margin-top: 8px;
      text-decoration: underline;
      cursor: pointer;
      font-size: inherit;
      color: inherit;
      font-family: inherit;
      font-weight: 300;
      display: block;
      width: 100%;
      text-align: left;
    `;
    
    // Add click handler for modal with robust z-index handling
    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const modal = document.getElementById('kvatt-modal-block');
      if (modal) {
        // Move modal to body to escape any stacking context issues
        // appendChild automatically moves the element if it's already in the DOM
        if (modal.parentElement !== document.body) {
          document.body.appendChild(modal);
        }
        
        // Apply maximum z-index and ensure visibility
        modal.style.display = 'block';
        modal.style.position = 'fixed';
        modal.style.zIndex = '2147483647';
        modal.style.top = '0';
        modal.style.left = '0';
        modal.style.width = '100%';
        modal.style.height = '100%';
        modal.style.visibility = 'visible';
        
        // Force a reflow to ensure styles are applied
        void modal.offsetHeight;
        
        // On mobile, also try to blur any focused elements that might interfere
        if (document.activeElement && document.activeElement.blur) {
          document.activeElement.blur();
        }
        
        // Close UpCart drawer if needed (optional - uncomment if desired)
        // if (window.upcart && window.upcart.close) {
        //   window.upcart.close();
        // }
      }
    });
    
    return button;
  }

  // Function to ensure button is present in description element
  function ensureButtonPresent() {
    if (!descriptionElement) return;
    
    let howItWorksButton = shadowRoot.querySelector('#kvatt-how-it-works-button');
    
    // Remove old button if it exists but is orphaned
    if (howItWorksButton && !descriptionElement.contains(howItWorksButton) && !shadowRoot.contains(howItWorksButton)) {
      howItWorksButton = null;
    }
    
    // Create button if it doesn't exist
    if (!howItWorksButton) {
      howItWorksButton = createHowItWorksButton();
    }
    
    // Ensure button is in description element
    if (descriptionElement && !descriptionElement.contains(howItWorksButton)) {
      descriptionElement.appendChild(howItWorksButton);
    }
  }

  // Initial button setup
  ensureButtonPresent();
  
  // Watch for description element changes to re-add button if removed
  if (descriptionElement) {
    const descriptionObserver = new MutationObserver(() => {
      ensureButtonPresent();
    });
    
    descriptionObserver.observe(descriptionElement, {
      childList: true,
      subtree: true
    });
  }

  // Check initial state and apply changes if needed
  const isInitiallyActive = toggleSwitch.classList.contains('styles_ToggleSwitch--active__');
  if (isInitiallyActive) {
    if (titleElement) {
      titleElement.textContent = "Congratulations!";
    }
    if (descriptionElement) {
      // Update description but preserve the button
      descriptionElement.innerHTML = "You just joined the Waste Less Club by making your order greener.";
      ensureButtonPresent();
    }
    
    // Apply CSS content for ::after pseudo-element on initial load
    const style = document.createElement('style');
    style.textContent = `
      .upcart-addons-toggle::after { content: "-£3.99" !important; }
      .styles_AddonsModule__toggle__::after { content: "-£3.99" !important; }
      .upcart-addons-toggle .styles_ToggleSwitch--active__::after { content: "-£3.99" !important; }
      .upcart-addons-toggle .styles_ToggleSwitch__::after { content: "-£3.99" !important; }
    `;
    style.id = 'upcart-toggle-active-style';
    document.head.appendChild(style);
    
    // Also try to add the style directly to the shadow root
    if (shadowRoot) {
      const shadowStyle = document.createElement('style');
      shadowStyle.textContent = `
        .upcart-addons-toggle::after { content: "-£3.99" !important; }
        .styles_AddonsModule__toggle__::after { content: "-£3.99" !important; }
      `;
      shadowStyle.id = 'upcart-toggle-active-shadow-style';
      shadowRoot.appendChild(shadowStyle);
    }
  }

  // Monitor class changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const isActive = toggleSwitch.classList.contains('styles_ToggleSwitch--active__');
        
        if (isActive) {
          // Update text when active
          if (titleElement) {
            titleElement.textContent = "Congratulations!";
          }
        if (descriptionElement) {
          // Update description but preserve the button
          descriptionElement.innerHTML = "You just joined the Waste Less Club by making your order greener.";
          ensureButtonPresent();
        }
        
        // Update CSS content for ::after pseudo-element
        // Try multiple approaches to ensure the CSS applies
        const style = document.createElement('style');
        style.textContent = `
          .upcart-addons-toggle::after { content: "-£3.99" !important; }
          .styles_AddonsModule__toggle__::after { content: "-£3.99" !important; }
          .upcart-addons-toggle .styles_ToggleSwitch--active__::after { content: "-£3.99" !important; }
          .upcart-addons-toggle .styles_ToggleSwitch__::after { content: "-£3.99" !important; }
        `;
        style.id = 'upcart-toggle-active-style';
        document.head.appendChild(style);
        
        // Also try to add the style directly to the shadow root
        if (shadowRoot) {
          const shadowStyle = document.createElement('style');
          shadowStyle.textContent = `
            .upcart-addons-toggle::after { content: "-£3.99" !important; }
            .styles_AddonsModule__toggle__::after { content: "-£3.99" !important; }
          `;
          shadowStyle.id = 'upcart-toggle-active-shadow-style';
          shadowRoot.appendChild(shadowStyle);
        }
        } else {
          // Revert to original text when inactive
          if (titleElement) {
            titleElement.textContent = originalTitle;
          }
        if (descriptionElement) {
          // Revert to original description but preserve the button
          descriptionElement.innerHTML = originalDescription;
          ensureButtonPresent();
        }
        
        // Remove custom CSS style to revert ::after content
        const existingStyle = document.getElementById('upcart-toggle-active-style');
        if (existingStyle) {
          existingStyle.remove();
        }
        
        // Also remove shadow root style
        if (shadowRoot) {
          const shadowStyle = shadowRoot.getElementById('upcart-toggle-active-shadow-style');
          if (shadowStyle) {
            shadowStyle.remove();
          }
        }
        }
      }
    });
  });

  observer.observe(toggleSwitch, {
    attributes: true,
    attributeFilter: ['class']
  });
}
